import Box from "@/common/components/Box";
import Skeleton from '@/common/components/Skeleton';

const ProductDistributionFormItemLoadingState = () => {
  return (
    <Box className="flex flex-col gap-4">
      <div className="rounded-sm w-fit bg-neutral-op-8">
        <div className="flex gap-1 items-center px-3 py-2">
          <Skeleton circle height={24} />
          <Skeleton width={128} />
        </div>
      </div>

      <div className='flex flex-col gap-1'>
        <Skeleton height={52} className='bg-white-200 rounded-md' />

        <div className='grid grid-cols-3 gap-3'>
          <Skeleton />

          <Skeleton />

          <Skeleton />
        </div>
      </div>
    </Box>
  );
};

export default ProductDistributionFormItemLoadingState;
